export interface VecLike{
	readonly x:number;
	readonly y:number;
	readonly z?:number;
}

export interface Vec2Like{
	readonly x:number;
	readonly y:number;
}

export interface Vec3Like{
	readonly x:number;
	readonly y:number;
	readonly z:number;
}
